export default __webpack_public_path__ + "static/media/MASTERCARD_card.80ee4ce1.svg";